<template>
  <div>
    <div v-if="detail_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;
         background-color:rgba(255,255,255,0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 class="text-xs-right" mt-3>
<!--          <v-menu offset-y>-->
<!--            <v-btn slot="activator" color="rgb(248 71 6)" class="white&#45;&#45;text yatri_button">-->
<!--              <router-link to="/announcements" class="white&#45;&#45;text">-->
<!--                <v-icon color="#bbbbc6" class="white&#45;&#45;text">list</v-icon>-->
<!--                &nbsp&nbsp Announcement List-->
<!--              </router-link>-->
<!--            </v-btn>-->
<!--          </v-menu>-->


          <v-card>
            <v-form
                id="update_trip_announcement"
                @submit.prevent="validateBeforeSubmit('updateTripAnnouncement')"
                data-vv-scope="updateTripAnnouncement"
                ref="update_trip_announcement"
                v-model="validateTripUpdate"
            >
            <v-card-text>
              <v-container fluid grid-list-md
                           style="margin-left:4px;line-height: 20px;text-align: -webkit-left;padding-bottom: 10px;">
                <v-layout row wrap>
                  <v-flex xs12 md8 lg4>
                    <label>Train Update Type</label>
                    <v-autocomplete
                        :items="announcement_types"
                        name="Train Update Type"
                        label="Select Train Update Type"
                        v-model="announcement_detail.type"
                        return-object
                        item-text="title"
                        item-value="id"
                        v-validate="'required'"
                        solo flat
                        disabled
                        :error-messages="errors.collect('updateTripAnnouncement.Announcement Type')"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md8 lg4 v-if="announcement_detail">
                    <label>Train Code</label>
                    <v-autocomplete
                        :items="train_codes"
                        v-model="announcement_detail.train_code"
                        name="Train Code"
                        label="Select Train Code"
                        return-object
                        :item-text=getItemText
                        :item-value="'number'"
                        solo flat
                        v-validate="'required'"
                        @change="populate_announcement()" :menu-props="{closeOnContentClick:true}"
                        :error-messages="errors.collect('updateTripAnnouncement.Train Code')"
                    >
                    </v-autocomplete>
                  </v-flex>
<!--                  <v-flex xs12 md8 lg4>-->
<!--                    <label>Affected Date</label>-->
<!--                    <flat-pickr-->
<!--                        class="flatpickerCSS2"-->
<!--                        v-model="announcement_detail.affected_date"-->
<!--                        :config="config"-->
<!--                        placeholder="Date"-->
<!--                        name="Relevant from"/>-->
<!--                  </v-flex>-->
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg8>
                    <label>Short Description: </label>
                    <v-textarea
                        name="Short_Description"
                        v-model="announcement_detail.short_description"
                        rows="2"
                        v-validate="'required'"
                        solo flat
                        :error-messages="errors.collect('updateTripAnnouncement.Short Description')"
                        clearable>
                    </v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 lg8>
                    <label>Description: </label>
                    <v-textarea
                        name="Description"
                        v-model="announcement_detail.long_description"
                        rows="2"
                        v-validate="'required'"
                        solo flat
                        :error-messages="errors.collect('updateTripAnnouncement.Description')"
                        readonly>
                    </v-textarea>
                  </v-flex>
                </v-layout>
                <br>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small v-if="this.announcement_detail.type == '1' ||
                  this.announcement_detail.type == '5' ||
                  this.announcement_detail.type == '7' ||
                  this.announcement_detail.type == '8'" 
                     :disabled="(announcement_detail.short_description == '' ||
                  announcement_detail.train_code.number == '' || announcement_detail.type == '')"
                     @click="confirm_to_publish_announcement_dialog = true">Update
              </v-btn>

              <v-btn color="primary" small v-if="this.announcement_detail.type == '3'"
                     :disabled="((announcement_detail.short_description == '' ||
                  announcement_detail.train_code.number == '' || announcement_detail.type == '') ||
                  (/\d/.test((announcement_detail.short_description).slice(-20)) != true))"
                     @click="confirm_to_publish_announcement_dialog = true">Update
              </v-btn>

              <v-btn flat small to="/trip-announcements">Cancel</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="confirm_to_publish_announcement_dialog" scrollable :overlay="false" max-width="450px"
                transition="dialog-transition" persistent>
        <v-card>
          <v-card-title primary-title>
            <!--            <v-flex xs12 md12>-->
            <!--              <label class="heading"><b>Title : </b></label>-->
            <!--              <span>{{ cache_announcement_title}}</span>-->
            <!--            </v-flex>-->
            <br>
            <v-flex xs12 md12 style="margin-top: 5px;">
              <label class="heading"><b>Description : </b></label>
              <ul>
                <li v-for="(item) in announcement_object_ids" :key="item.number">
                  <span><b>{{"Train Number : "}}</b> {{item.number}}</span><br />
                  <span><b>{{"Description : "}}</b> {{item.long_description}}</span>
                  <br /><br />
                </li>
              </ul>
<!--              <span>{{ cache_announcement_long_description }}</span>-->
            </v-flex>

            <v-flex xs12 md12><br/></v-flex>

            <span class="subheading">Are you sure you wish to update this Train Update?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="confirm_to_publish_announcement_dialog = false, confirm_button_loader=false">No</v-btn>
            <v-btn small color="primary" type="submit" @click="updateTripAnnouncement()"
                   :loading="confirm_button_loader">Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                  :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <v-btn
            text
            dark
            @click="snackbar.display = false"
        >
          <v-icon
              right
              color="white"
          >
            close
          </v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>

  </div>
</template>

<script>
import moment from "moment";
// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
import axios from 'axios'


export default {
  name: "Detail",
  components:{
    // flatPickr
  },
  watch:{
    "announcement_detail.train_code":function (val) {
      if (val != '' && this.announcement_detail.type != '') {
        // if (this.announcement_detail.type_object.id == 1 || this.announcement_detail.type_object.id == 3 ||
        //     this.announcement_detail.type_object.id == 5) {
        //   this.populate_announcement();
        // }
        //
        // if (this.announcement_detail.type_object.id == 1) {
        //   this.announcement_detail.short_description = "Cancelled";
        // } else if (this.announcement_detail.type_object.id == 3) {
        //   this.announcement_detail.short_description = "";
        // } else if (this.announcement_detail.type_object.id == 5) {
        //   this.announcement_detail.short_description = "";
        // }
      }
    },
    "announcement_detail.short_description": {
      immediate: true, // Update immediately on component mount
      handler(val) {
        if(val != ''){
          this.announcement_object_ids.forEach((element) => {
            this.announcement_detail.long_description = element.old;
            //this.computed_short_description;
            this.announcement_detail.long_description = this.announcement_detail.long_description +
                this.computed_short_description;
            element.long_description = this.announcement_detail.long_description;
          });

        }else if(val == ''){
          this.announcement_detail.long_description = this.populated_announcement;

        }
      }
    },
  },
  methods: {
    getTripAnnouncementDetails(){
      this.detail_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/trip-announcement/` +
              this.$route.params.id
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.announcement_detail = response.data.data[0];

              this.announcement_object_ids = [response.data.data[0]];

              if((this.announcement_detail.short_description).length != 0){
                this.short_description_length = (this.announcement_detail.short_description).length
              }else{
                this.short_description_length = 1
              }

              this.announcement_detail.train_code = this.announcement_detail.local_train_number;
              this.new_train_number = this.announcement_detail.local_train_number;
              this.announcement_detail.type = this.announcement_detail.type_object.id;
              this.announcement_detail.long_description = this.computed_long_description_without_short;

              this.announcement_object_ids.forEach((element) => {
                element.long_description = this.announcement_detail.long_description;
                element.old = this.announcement_detail.long_description;
              });
              this.populated_announcement = this.announcement_detail.long_description;
              this.detail_loader = false;
            }
          })
          .catch(() => {
            this.detail_loader = false;
          });
    },
    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/wa-announcer/announcement-types`,
              {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.announcement_types = response.data.types;
            }
          })
    },
    getItemText(item) {
      return `${item.number} - ${item.short_code}`;
    },
    getTrainCodes: function () {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-codes`,
          {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.train_codes = response.data.train_codes;
            }
          })
    },
    updateTripAnnouncement(){
      this.confirm_button_loader = true;
      let update_announcements = {};//Object.assign({}, this.announcement_detail);
      update_announcements.local_train_number = this.new_train_number;
      update_announcements.id = this.announcement_detail.id;

      this.announcement_object_ids.forEach((element) => {
        update_announcements.description = element.long_description;
        update_announcements.title = element.title;
      });
      update_announcements.affected_date = this.announcement_detail.affected_date;
      update_announcements.short_description = this.announcement_detail.short_description;


      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-trip-announcement`,
          update_announcements).then((response) =>{
            if(response.data.status == 1){
              this.announcement_id = response.data.announcement.id;
              // this.updateStatus();
              this.confirm_to_publish_announcement_dialog = false;
              this.confirm_button_loader = false;
              this.status_model = false;
              this.$router.push({
                name: 'trip-announcements',
                params: { message: response.data.message },
                query: this.$route.query || {}
              });

            }else if (response.data.status == 0) {
              this.confirm_to_publish_announcement_dialog = false;
              this.confirm_button_loader = false;
              this.status_model = false;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
              this.$validator.reset();
            }
      })
    },
    populate_announcement: function() {
      // this.submit_loader =true;
      this.startLoading();
      let new_announcement = {};

      let data = [this.announcement_detail.train_code];
      new_announcement.announcement_type_id = this.announcement_detail.type;
      new_announcement.train_number = data;

      this.new_train_number = this.announcement_detail.train_code.number;
      this.announcement_detail.short_description = '';
      this.announcement_detail.long_description = '';
      this.populated_announcement = '';

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/populate-announcement-template`,
          new_announcement)
          .then((response)=>{
            if(response.data.status == 1)
            {

              this.announcement_object_ids = response.data.data;

              this.announcement_object_ids.forEach((element) => {
                element.old = element.long_description;
                this.announcement_detail.long_description = element.long_description;
                this.announcement_detail.long_description = this.announcement_detail.long_description +
                    this.announcement_detail.short_description;

                this.announcement_detail.title = element.title;

                element.long_description = element.long_description + this.computed_short_description;

                if (this.announcement_detail.type_object.id == 1) {
                  this.announcement_detail.short_description = "Cancelled";
                } else if (this.announcement_detail.type_object.id == 3) {
                  this.announcement_detail.short_description = "";
                } else if (this.announcement_detail.type_object.id == 5) {
                  this.announcement_detail.short_description = "";
                }
              });


              // this.submit_loader = false;
              this.stopLoading();
            }else {
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }

          }).catch((error)=>{
        // eslint-disable-next-line no-console
        console.log(error);
      }).finally(()=>{
        this.stopLoading();
      });
    },
    validateBeforeSubmit(scope){
      this.$validator.validateAll(scope).then((result) =>{
        if(result){
          this[scope]();
        }
      } )
    },
    // updateStatus: function () {
    //   this.announcement_status = "Publish";
    //   axios.post(`${process.env.VUE_APP_API_URL}/api/v1/publish-announcement`, {
    //     announcement_id: this.announcement_id,
    //     status: this.announcement_status
    //   }, {headers: this.$headers}).then((response) => {
    //     if (response.data.status == 1) {
    //       this.confirm_to_publish_announcement_dialog = false;
    //       this.confirm_button_loader = false;
    //       this.status_model = false;
    //       this.$router.push({name: 'trip-announcements', params:{message: response.data.message}});
    //     }else if(response.data.status == 0){
    //       this.confirm_to_publish_announcement_dialog = false;
    //       this.confirm_button_loader = false;
    //       this.status_model = false;
    //       this.snackbar.message = response.data.message;
    //       this.snackbar.show = true;
    //     }
    //     if (response.data.status == 2) {
    //       this.snackbar.message = response.data.message;
    //       this.snackbar.show = true;
    //     }
    //
    //   }).catch((error) => {
    //
    //   }).finally(() => {
    //
    //   });
    // },
  },
  data() {
    return {
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 3000
      },
      announcement_detail: {
        type:"",
        train_code: [],
        description:"",
        title: "",
        short_description: '',
        long_description: "",
        affected_date: '',
      },
      detail_loader: false,
      announcement_types: [],
      local_lines: [],
      train_codes: [],
      validateTripUpdate: '',
      announcement_title: '',
      announcement_description: '',
      confirm_to_publish_announcement: '',
      confirm_to_publish_announcement_dialog: false,
      announcement_status: '',
      announcement_id: '',
      cache_announcement_title: '',
      cache_announcement_long_description: '',
      confirm_button_loader: false,
      new_train_number: '',
      populated_announcement: '',
      short_description_length: 0,
      result: {},
      announcement_ids: [],
      announcement_object_ids: {
        type:"",
        train_code: [],
        description:"",
        title: "",
        short_description: '',
        long_description: "",
        affected_date: '',
        old: '',
      },
      config: {
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        time_24hr: false,
        minDate: moment().format('YYYY-MM-DD'),
      }
    }
  },
  computed:{
    computed_short_description(){
      return (this.announcement_detail.short_description == null ||
          this.announcement_detail.short_description == '')
          ? '' : this.announcement_detail.short_description;
    },
    computed_long_description_without_short(){
        return (this.announcement_detail.description).slice(0,-this.short_description_length)
    }
  },
  mounted() {
    this.getTripAnnouncementDetails();
    this.getTypeList();
    this.getTrainCodes();
    // this.announcement_detail.affected_date = moment().format('YYYY-MM-DD');

  }
}
</script>

<style scoped>

</style>
